/**
 * Created by RKL on 13/08/2015.
 */
define('runDetailTabView',[
  'module',
  'runCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!runDetailTabTpl'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl
) {
  'use strict';

  var RunDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.viewLess = this.model.get('secId');
      switch (templateData.plateRowNb) {
        case 'A': templateData.plateRowNb = 1; break;
        case 'B': templateData.plateRowNb = 2; break;
        case 'C': templateData.plateRowNb = 3; break;
        case 'D': templateData.plateRowNb = 4; break;
        case 'E': templateData.plateRowNb = 5; break;
        case 'F': templateData.plateRowNb = 6; break;
        case 'G': templateData.plateRowNb = 7; break;
        case 'H': templateData.plateRowNb = 8; break;
      }
      return templateData;
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        runModel: this.model
      });
      createEditView.show({
        title: _.i18n('run.edit')
      });
    }

  });

  module.exports = RunDetailView;
});
